"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.function.name");
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _router = _interopRequireDefault(require("./router"));
var _store = _interopRequireDefault(require("./store"));
var _elementUi = require("element-ui");
var _nprogress = _interopRequireDefault(require("nprogress"));
require("nprogress/nprogress.css");
var _auth = require("@/utils/auth");
var _getPageTitle = _interopRequireDefault(require("@/utils/get-page-title"));
// progress bar
// progress bar style
// get token from cookie

_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login', '/']; // no redirect whitelist

_router.default.beforeEach(/*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(to, from, next) {
    var hasToken, _yield$store$dispatch, roles, newList, hasRoles, _yield$store$dispatch2, _roles, accessRoutes, _t;
    return (0, _regenerator2.default)().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          // start progress bar
          _nprogress.default.start();

          // set page title
          document.title = (0, _getPageTitle.default)(to.meta.title);

          // determine whether the user has logged in
          hasToken = (0, _auth.getToken)();
          if (!hasToken) {
            _context.n = 13;
            break;
          }
          if (!(to.path === '/login')) {
            _context.n = 6;
            break;
          }
          if (!(_store.default.getters.appId !== '')) {
            _context.n = 3;
            break;
          }
          _context.n = 1;
          return _store.default.dispatch('user/getInfo');
        case 1:
          _yield$store$dispatch = _context.v;
          roles = _yield$store$dispatch.roles;
          _context.n = 2;
          return _store.default.dispatch('permission/generateRoutes', roles);
        case 2:
          newList = _context.v;
          if (newList.length > 0 && newList[0].path) {
            _router.default.addRoutes(newList);
            next((0, _objectSpread2.default)((0, _objectSpread2.default)({}, newList[0]), {}, {
              replace: true
            }));
          }
          _context.n = 5;
          break;
        case 3:
          _context.n = 4;
          return _store.default.dispatch('user/resetToken');
        case 4:
          next();
        case 5:
          _nprogress.default.done();
          // return
          _context.n = 12;
          break;
        case 6:
          // determine whether the user has obtained his permission roles through getInfo
          // const hasRoles = store.getters.roles && store.getters.roles.length > 0
          // const hasRoles = store.state.permission.routes && store.state.permission.routes.length > 0
          hasRoles = _store.default.state.user.treeRouters && _store.default.state.user.treeRouters.length > 0;
          if (!hasRoles) {
            _context.n = 7;
            break;
          }
          if (_store.default.getters.breadList.filter(function (i) {
            return i.path === to.fullPath;
          }).length === 0) {
            // 面包屑导航的逻辑
            if (to.name === 'userDetails') {
              _store.default.commit('user/SET_BREADLIST', _store.default.getters.breadList.concat([{
                path: to.fullPath,
                title: to.meta.title + '_' + to.query.nickname,
                isMore: to.meta.isMore
              }]));
            } else if (to.name === 'appDetail') {
              _store.default.commit('user/SET_BREADLIST', _store.default.getters.breadList.concat([{
                path: to.fullPath,
                title: to.meta.title + '_' + to.query.name,
                isMore: to.meta.isMore
              }]));
            } else if (to.name === 'renovation') {
              _store.default.commit('user/SET_BREADLIST', _store.default.getters.breadList.concat([{
                path: to.fullPath,
                title: to.meta.title + '_' + to.query.activityName,
                isMore: to.meta.isMore
              }]));
            } else if (to.name === 'home_renovation') {
              _store.default.commit('user/SET_BREADLIST', _store.default.getters.breadList.concat([{
                path: to.fullPath,
                title: to.meta.title + '_' + to.query.activityName,
                isMore: to.meta.isMore
              }]));
            } else if (to.name === 'userCenter_renovation') {
              _store.default.commit('user/SET_BREADLIST', _store.default.getters.breadList.concat([{
                path: to.fullPath,
                title: to.meta.title + '_' + to.query.activityName,
                isMore: to.meta.isMore
              }]));
            } else {
              _store.default.commit('user/SET_BREADLIST', _store.default.getters.breadList.concat([{
                path: to.fullPath,
                title: to.meta.title,
                isMore: to.meta.isMore
              }]));
            }
            _store.default.commit('user/SET_NUM', _store.default.getters.breadList.length - 1);
          } else {
            _store.default.getters.breadList.map(function (i, index) {
              if (i.path === to.fullPath) {
                _store.default.commit('user/SET_NUM', index);
              }
            });
          }
          next();
          _context.n = 12;
          break;
        case 7:
          _context.p = 7;
          _context.n = 8;
          return _store.default.dispatch('user/getInfo');
        case 8:
          _yield$store$dispatch2 = _context.v;
          _roles = _yield$store$dispatch2.roles;
          _context.n = 9;
          return _store.default.dispatch('permission/generateRoutes', _roles);
        case 9:
          accessRoutes = _context.v;
          // dynamically add accessible routes
          // console.log(
          //   router,
          //   roles,
          //   accessRoutes
          // )
          _router.default.addRoutes(accessRoutes);
          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next((0, _objectSpread2.default)((0, _objectSpread2.default)({}, to), {}, {
            replace: true
          }));
          _context.n = 12;
          break;
        case 10:
          _context.p = 10;
          _t = _context.v;
          _context.n = 11;
          return _store.default.dispatch('user/resetToken');
        case 11:
          _elementUi.Message.error(_t || 'Has Error');
          next("/login?redirect=".concat(to.path));
          _nprogress.default.done();
        case 12:
          _context.n = 16;
          break;
        case 13:
          if (!(whiteList.indexOf(to.path) !== -1)) {
            _context.n = 14;
            break;
          }
          // in the free login whitelist, go directly
          next();
          _context.n = 16;
          break;
        case 14:
          _context.n = 15;
          return _store.default.dispatch('user/resetToken');
        case 15:
          next("/login?redirect=".concat(to.path));
          _nprogress.default.done();
        case 16:
          return _context.a(2);
      }
    }, _callee, null, [[7, 10]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
_router.default.afterEach(function () {
  // finish progress bar
  _nprogress.default.done();
});